// extracted by mini-css-extract-plugin
module.exports = {"order__category":"OrderCategoryTitle_order__category__mmPLa","order__category_root":"OrderCategoryTitle_order__category_root__82LuA"};